import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { DEFAULT_BULK_ACTIONS_EDIT_MODAL_KEY } from '../../constants/modalKeys';
import { BaseBulkActionButton } from './BaseBulkActionButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useBulkActionsIsLoading } from '../../hooks/useBulkActionsIsLoading';
import { useBulkActionsHasError } from '../../hooks/useBulkActionsHasError';
import { useBulkActionsPermissionsForCurrentSelection } from '../../hooks/useBulkActionsPermissionsForCurrentSelection';
import invariant from 'react-utils/invariant';
import { useBulkActionsOpenModal } from '../../hooks/useBulkActionsOpenModal';
import { jsx as _jsx } from "react/jsx-runtime";
const falseFunction = () => false;
export const Edit = ({
  modalProps,
  logOnClick,
  children,
  disabledState
}) => {
  invariant(modalProps && typeof modalProps.hasAllScopes === 'function', 'customer-data-bulk-actions.Edit.props.modalProps.hasAllScopes must be a function, but got "%s"', modalProps && modalProps.hasAllScopes);
  // TODO: Add invariant for hasAllGates. Not adding right away because it would
  // break the index page at runtime.

  const openModal = useBulkActionsOpenModal();
  const hasAllScopes = modalProps && modalProps.hasAllScopes || falseFunction;
  const hasAllGates = modalProps && modalProps.hasAllGates || falseFunction;
  const onSuccess = modalProps && modalProps.onSuccess;
  const onFailure = modalProps && modalProps.onFailure;
  const logEdited = modalProps && modalProps.logEdited;
  const filterProperty = modalProps && modalProps.filterProperty;
  const isLoading = useBulkActionsIsLoading();
  const hasError = useBulkActionsHasError();
  const canEditAllSelectedObjects = useBulkActionsPermissionsForCurrentSelection('canEdit');
  const disabled = disabledState && disabledState.isDisabled || isLoading || hasError || !canEditAllSelectedObjects;
  const onClick = () => {
    if (logOnClick) {
      logOnClick();
    }
    openModal({
      modalKey: DEFAULT_BULK_ACTIONS_EDIT_MODAL_KEY,
      props: {
        hasAllGates,
        hasAllScopes,
        onSuccess,
        onFailure,
        logEdited,
        filterProperty
      }
    });
  };
  return /*#__PURE__*/_jsx(BaseBulkActionButton, {
    icon: "edit",
    disabled: disabled,
    onClick: onClick,
    isLoading: isLoading,
    disabledTooltip: disabledState && disabledState.isDisabled ? disabledState.disabledTooltip : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "bulkActions.buttonDisabledTooltips.edit"
    }),
    "data-selenium-test": "bulk-action-edit",
    "data-test-id": "bulk-action-edit",
    children: children !== null && children !== void 0 ? children : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "bulkActions.buttonLabels.edit"
    })
  });
};